export class ActiveAssistModel {
  public activeAssistId: string;
  public created: any;
  public started: any;
  public ended: any;

  constructor(activeAssistRecord) {
    this.activeAssistId = activeAssistRecord.ActiveAssistID;
    this.created = activeAssistRecord.Created;
    this.started = activeAssistRecord.Started;
    this.ended = activeAssistRecord.Ended;
  }

  static wrap(record) {
    return new ActiveAssistModel(record);
  }
}
